import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
//tính toán phức tạp ở trên {logic code}
//


//Render in ra dữ liệu, nên code chỉ xử lý đơn giản
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <App/>
);